import { render, staticRenderFns } from "./CustomerQuotesAdd.vue?vue&type=template&id=37fd9830&scoped=true&"
import script from "./CustomerQuotesAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerQuotesAdd.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQuotesAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerQuotesAdd.vue?vue&type=style&index=1&id=37fd9830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd9830",
  null
  
)

export default component.exports